import { Configuration } from '~/core/configuration/configuration.type';
import { nativeSearchInput } from './nativeSearchInput';

const sendEventToGA = (searchTerm: string): Promise<boolean> => {
    return new Promise((resolve) => {
        const eventData = {
            native_search_term: searchTerm,
        };

        window.dataLayer.push({
            event: 'native_search',
            gtm: { ...eventData },
        });

        if (window.gtag && typeof window.gtag === 'function') {
            window.gtag('event', 'Native Search', eventData);
        }

        resolve(true);
    });
};

export const handleNativeSearchAnalytics = (configuration: Configuration): void => {
    if (
        !configuration.layout.configuration.ABTesting?.nativeSearchAnalytics?.enabled ||
        !configuration.layout.configuration.ABTesting?.nativeSearchAnalytics?.handlers ||
        !configuration.layout.configuration.ABTesting?.nativeSearchAnalytics?.handlers.length
    ) {
        return;
    }

    const { handlers } = configuration.layout.configuration.ABTesting.nativeSearchAnalytics;

    handlers.forEach((handlerConfig) => {
        switch (handlerConfig.type) {
            case 'input':
                nativeSearchInput(handlerConfig, sendEventToGA);
                break;
        }
    });
};
